import { CellPlugin, ImageUploadType } from '../../../editor';
import lazyLoad from '../../../editor/core/helper/lazyLoad';
import createPlugin from './createPlugin';
import ImageHtmlRenderer from './Renderer/ImageHtmlRenderer';
import type { ImageSettings } from './types/settings';
import type { ImageState } from './types/state';

const ImageControls = lazyLoad(() => import('./Controls/ImageControls'));

const imagePlugin: (
  settings?: Partial<ImageSettings>
) => CellPlugin<ImageState> = (settings) =>
  createPlugin({
    Renderer: ImageHtmlRenderer,
    Controls: ImageControls as any,
    ...settings,
  });

const image = imagePlugin();
export default image;
export { imagePlugin };
export type { ImageUploadType };
